import React from 'react';
import Layout from '../../Shared/Layout';
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import Add from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import ReorderIcon from '@material-ui/icons/Reorder';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Language from "@material-ui/icons/Language";
import {InertiaLink} from "@inertiajs/inertia-react";
import DescriptionIcon from '@material-ui/icons/Description';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import {Trans} from "../../utils/i18n";
import Button from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";

const Card = styled.div`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 3rem;
  font-size: 2rem;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
  height: 100%;
`;

const Wrapper = styled.div`
  margin-top: 15rem;
`;

const Title = styled.h2`
    color: ${props => props.theme.primary};
`;

export default function Activate({ emailVerified, userActivated }) {
    return (
        <Wrapper>
            <Container maxWidth="lg">
                <Grid container spacing={3} justify={'center'}>
                    <Grid item xs={12} sm={6}>
                        <Card>
                            {
                                !emailVerified && <Trans i18nKey={'auth.verifyEmail'}>Thank you for your registration. Please verify your email address by clicking on the link in the email.</Trans>
                            }
                            {
                                !emailVerified && <Button
                                    color={'primary'}
                                    variant={'contained'}
                                    style={{ marginTop: 30 }}
                                    onClick={() => {
                                        Inertia.post(route('resendVerificationEmail'));
                                    }}
                                >
                                    <Trans i18nKey={'auth.resendVerificationEmail'}>Resend verification email </Trans>
                                </Button>
                            }
                            {
                                emailVerified && !userActivated && <Trans i18nKey={'auth.waitingForAccountActivation'}>Your account has to be activated by the B2X team. This can take up to two days.</Trans>
                            }
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Wrapper>
    )
}

Activate.layout = page => <Layout children={page} />;
